import {PrivateCommand} from "../PrivateCommand";
import {UIManager} from "../../../ui/u-i-manager";

export class ShowGdprPrivateCommand extends PrivateCommand {
    /* STATIC */

    /* INSTANCE */
    public execute(option?: string, callback?: Function): void {
        UIManager.openGDPR();
    }

}
